import { Link } from "react-router-dom";
import { Reveal, SectionLabel } from "@/components/Reveal";
import RegistrationForm from "@/components/RegistrationForm";
import { scrollToId } from "@/lib/attribution";
import { HOST, COMPLIANCE, COPYRIGHT, ASSETS } from "@/data/content";

const TRUST = [
  "100% free educational event — nothing to buy",
  "No hard credit pull required to attend",
  "Live Q&A — ask questions specific to your situation",
  "No obligation to speak with anyone afterward",
];

export const FinalRegister = () => (
  <section id="register" className="relative px-6 sm:px-12 lg:px-16 py-28 overflow-hidden grid-bg" data-testid="final-register-section">
    <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[600px] h-[600px] pointer-events-none" style={{ background: "radial-gradient(circle, rgba(217,98,43,0.14), transparent 65%)" }} />
    <div className="relative grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <SectionLabel num="009" text="FINAL CALL" />
        <Reveal>
          <h2 className="mt-6 final-h">YOUR NEXT MOVE STARTS WITH A CLEARER <span className="text-[#D9622B]">MAP.</span></h2>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-10 space-y-4">
            {TRUST.map((t) => (
              <li key={t} className="flex gap-3 text-[15px] text-white/65">
                <span className="text-[#D9622B] font-bold">✓</span>{t}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="w-full max-w-md lg:justify-self-end">
        <RegistrationForm variant="final" showBonuses={false} />
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="relative border-t border-white/10 px-6 sm:px-12 lg:px-16 pt-20 pb-10 overflow-hidden" data-testid="footer-section">
    <div className="footer-wordmark" aria-hidden="true">BOOTS-FIRST VA BENEFIT REVIEW</div>
    <div className="relative grid lg:grid-cols-3 gap-10 text-[13px] text-white/45">
      <div className="space-y-1.5">
        <span className="inline-flex items-center bg-white rounded px-3 py-2 mb-2" data-testid="footer-logo">
          <img src={ASSETS.logo} alt="Loan Factory" className="h-6 w-auto" />
        </span>
        <p className="font-bold text-white/70">{HOST.name}</p>
        <p>{HOST.company}</p>
        <p>NMLS# {HOST.nmls} · Company NMLS# {HOST.companyNmls}</p>
        <p>Licensed in Georgia, Florida, North Carolina & Tennessee</p>
      </div>
      <div className="space-y-1.5">
        <p className="font-mono text-[10px] tracking-[0.25em] text-white/30">CONTACT</p>
        <p>Phone: <a href={HOST.phoneHref} className="hover:text-white/70 transition-colors" data-testid="footer-phone">{HOST.phone}</a></p>
        <p>Email: <a href={`mailto:${HOST.email}`} className="hover:text-white/70 transition-colors" data-testid="footer-email">{HOST.email}</a></p>
        <p>Web: {HOST.website}</p>
      </div>
      <div className="space-y-1.5">
        <p className="font-mono text-[10px] tracking-[0.25em] text-white/30">LEGAL</p>
        <p><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white/70 transition-colors">Privacy Policy</Link></p>
        <p><Link to="/terms" data-testid="footer-terms-link" className="hover:text-white/70 transition-colors">Terms & Conditions</Link></p>
        <p><Link to="/disclaimer" data-testid="footer-disclaimer-link" className="hover:text-white/70 transition-colors">Disclaimer</Link></p>
      </div>
    </div>
    <div className="relative mt-12 pt-8 border-t border-white/[0.06] flex gap-4 items-start">
      <span className="text-2xl text-white/40" title="Equal Housing Lender">⌂</span>
      <p className="text-[11px] text-white/30 leading-relaxed max-w-3xl">{COMPLIANCE}</p>
    </div>
    <p className="relative mt-8 font-mono text-[10px] text-white/[0.15]">{COPYRIGHT}</p>
  </footer>
);

export const StickyCTA = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 p-3 md:hidden nav-glass border-t border-white/10" data-testid="mobile-sticky-cta">
    <button onClick={() => scrollToId("register")} className="w-full py-4 btn-primary text-black font-black text-sm tracking-[0.1em]">
      ✓ RESERVE MY FREE SEAT
    </button>
  </div>
);
